var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styles.features},[_c('section',[_c('h3',{staticClass:"color-gray-800 mb-8 fw-400"},[_vm._v("Additional Features:")]),_vm._t("features")],2),_c('section',[_c('h3',{staticClass:"color-gray-800 mb-8 fw-400"},[_vm._v("Support:")]),_vm._t("support")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }